/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditMentionsAuditMentionsMatchesListQueryResponse, AuditMentionsAuditMentionsMatchesListQueryParams } from "../models/AuditMentionsAuditMentionsMatchesList";

export function getAuditMentionsAuditMentionsMatchesListUrl() {
  const res = { method: 'GET', url: `/audit-mentions/v1/matches` as const }
  return res
}

/**
 * @description Returns paginated mention matches using the mi-api CRUD list contract. Filterable fields: `datetime`, `name`, `type`, `author`, `confidence`.
 * @summary List mention matches
 * {@link /audit-mentions/v1/matches}
 */
export async function auditMentionsAuditMentionsMatchesList(params: AuditMentionsAuditMentionsMatchesListQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AuditMentionsAuditMentionsMatchesListQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getAuditMentionsAuditMentionsMatchesListUrl().url.toString(), params, ... requestConfig })
  return res.data
}